<template>
    <div class="activity-dropdown-context">
        <p align="right" style="padding-top:20px;background:#fff" v-if="showContextMenu">
            <Dropdown :disabled="isDoingSomething" :transfer="true" trigger="click" @on-click="onSelect" style="margin-right: 27px;">
                <a href="javascript:void(0)">
                    <Icon size="25" type="ios-more" />
                </a>
                <DropdownMenu slot="list" style="text-align:left">
                    <DropdownItem :disabled="isDoingSomething" name="like">
                        {{ (elementItem.is_liked) ? "Liked" : "Like" }}</DropdownItem>
                    <DropdownItem :disabled="isDoingSomething" name="bookmark">
                        {{ (elementItem.bookmarked) ? "Bookmarked" : "Bookmark" }}</DropdownItem>
                    <!-- <DropdownItem :disabled="isDoingSomething" name="share">
                        Share</DropdownItem> -->
                </DropdownMenu>
            </Dropdown>
        </p>
    </div>
</template>

<script>
import * as API from '@/endpoints'
import { mapGetters } from 'vuex'
import _get from "lodash/get";
import Axios from "axios";
import VueCookie from "vue-cookie";

export default {
    props: {
        activityElement: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLikingElement: false,
            isBookmarkingElement: false,
            activity: {}
        }
    },
    computed: {
        ...mapGetters('user', ['userInfo']),
        showContextMenu() {
            console.log(_.get(this.activityElement, "type"), _.get(this.activityElement, "data.attachment_type"))
            if( _.get(this.activityElement, "type") == 'video' || _.get(this.activityElement, "type") == 'image') 
                return true;            
            if( _.get(this.activityElement, "type") == 'attachment') 
                if( _.get(this.activityElement, "data.attachment_type") == 'video' || _.get(this.activityElement, "data.attachment_type") == 'image') 
                    return true;            
            if( _.get(this.activityElement, "tags") ) {
                let findImage = _.get(this.activityElement, "tags").indexOf('sys_image')
                let findVideo = _.get(this.activityElement, "tags").indexOf('sys_video')
                if( findVideo >= 0 ||  findImage >= 0)
                    return true;
                return false;
            }
            return false;
        },
        isFloatingModule() {
            return this.$route.query.floating ? true : false;
        },
        isDoingSomething() {
            return (this.isLikingElement);
        },
        elementItem: {
            get() {
                this.$set(this.activityElement, "is_liked", _get(this.activityElement, "is_liked") ? 1 : 0);
                this.$set(this.activityElement, "bookmarked", _get(this.activityElement, "bookmarked") ? 1 : 0);
                return this.activityElement;
            },
            set(v) {
                this.activity = v;
            }
        }
    },
    methods: { 
        onSelect(name) {
            switch(name) {
                case "like":
                    // Do something
                    this.doLike();
                    break;
                case "bookmark":
                    // Do something
                    this.doBookmark();
                    break;
                case "share":
                    // Do something
                    this.doShare();
                    break;
            }
        },
        async doLike() {
            if( this.checkpoint() ) return false;

            let isLiked = _get(this.elementItem, "is_liked", 0)
            try {
                this.isLikingElement = true;
                let res = null;

                if( !isLiked )
                    res = await Axios.post(`${API.endpoints.activity}/${this.elementItem.activity_id}/like`)
                else 
                    res = await Axios.delete(`${API.endpoints.activity}/${this.elementItem.activity_id}/like`)

                if( res.status == 200 && _get(res, "data.is_liked")) {
                    this.$set(this.elementItem, "is_liked", _get(res, "data.is_liked") ? 1 : 0);
                    this.$Notice.success({
                        title: "Successfully liked"
                    })
                    this.doAction('like')
                } else if (res.status == 200 && _get(res, "data.success")) {
                    this.$Notice.success({
                        title: "Unliked"
                    })
                    this.$set(this.elementItem, "is_liked", 0);
                } else { 
                    this.$Message({
                        closable: true,
                        durationInSec: 3,
                        title: { content: "Error" },
                        message: { content: "Error liking, try again." }
                    });
                }

                this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: res.data.item_id, link_tag: `Course activity like`});
            } catch(e) {
                console.log(e)
                this.$Message({
                    closable: true,
                    durationInSec: 3,
                    title: { content: "Error" },
                    message: { content: _get(e, "response.data.error.message", "Error liking, try again.") }
                });
            } finally {
                this.isLikingElement = false;
            }
        },
        async doBookmark() {
            if( this.checkpoint() ) return false;

            let isBookmarked = _get(this.elementItem, "bookmarked", 0)
            try {
                this.isBookmarkingElement = true;
                let res = null;

                if( !isBookmarked ) {
                    res = await Axios.post(`${API.endpoints.bookmark}`, {
                        item_id: this.elementItem.id,
                        type: "careplan_item"
                    })
                } else {
                    res = await Axios.delete(`${API.endpoints.bookmark}/${this.elementItem.bookmark_id}`)
                }

                if( res.status == 200 && _get(res, "data.data.bookmarked")) {
                    this.$set(this.elementItem, "bookmarked", _get(res, "data.data.bookmarked"));
                    this.$set(this.elementItem, "bookmark_id", _get(res, "data.data.bookmark_id"));
                    this.$Notice.success({
                        title: "Successfully bookmarked"
                    })
                    this.doAction('bookmark')
                } else if (res.status == 200 && _get(res, "data.success")) {
                    this.$Notice.success({
                        title: "Unbookmarked"
                    })
                    this.$set(this.elementItem, "bookmarked", 0);
                } else {
                    this.$Message({
                        closable: true,
                        durationInSec: 3,
                        title: { content: "Error" },
                        message: { content: "Error bookmarking, try again." }
                    });
                }

                this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: res.data.item_id, link_tag: `Course bookmark activity`});
            } catch(e) {
                console.log(e.response)
                this.$Message({
                    closable: true,
                    durationInSec: 3,
                    title: { content: "Error" },
                    message: { content: _get(e, "response.data.error.message", "Error bookmarking, try again.") }
                });
            } finally {
                this.isBookmarkingElement = false;
            }
        },
        doShare() {
            // Do something
        },
        checkpoint() {
            if( this.userInfo.user_type == 'guest') {
                this.$store.commit('hitCheckpoint')
                return true;
            }
            return false;
        },
        doAction(action) {
            if (!this.isFloatingModule) {
                let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
                this.$store.dispatch("points/setUserActionPoints", {
                    action,
                    user_story_id: engageCourse.userStory,
                    track_id: engageCourse.course,
                    module_id: engageCourse.article,
                    category: engageCourse.category,
                    element_id: this.activityElement.id
                }, { root: 1 });
            } else {
                this.$store.dispatch("points/setUserActionPoints", {
                    action,
                    element_id: this.activityElement.id
                }, { root: 1 });
            }
        }
    }
}
</script>